import _ from 'lodash';

export const selectLoader = (state) => _.get(state, ['loader'], false);